import { render } from "./ai-form-tag-box.vue?vue&type=template&id=317dd495"
import script from "./ai-form-tag-box.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-form-tag-box.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/card-component/ai-form-tag-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "317dd495"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('317dd495', __exports__)) {
    api.reload('317dd495', __exports__)
  }
  
  module.hot.accept("./ai-form-tag-box.vue?vue&type=template&id=317dd495", () => {
    api.rerender('317dd495', render)
  })

}


export default __exports__